import { render, staticRenderFns } from "./SymptomCodes.vue?vue&type=template&id=1d30c1c2&"
import script from "./SymptomCodes.vue?vue&type=script&lang=js&"
export * from "./SymptomCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports